import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';


const EsReqDvryGuideBlock = styled.div`
  ${isMobileOnly&&`
  td {
    position:unset;
    &:first-of-type {width:30vw;text-align:center;font-size:0.8em;word-break: keep-all;}
  }`};

`;

const EsReqDvryGuide = ({ detailInfo }) => {

    const getDvryType = () => {

        let resobj = '';
        if (detailInfo.brandinfo.dlvry_method === '025101') {
            resobj = "업체직접배송";
        }
        else if (detailInfo.brandinfo.dlvry_method === '025102') {
            resobj = "일반택배";

        } else if (detailInfo.brandinfo.dlvry_method === '025103') {
            resobj = "화물택배";
        }

        if (detailInfo.brandinfo.is_quick) {
            resobj += " / 퀵배송";
        }

        return resobj;
    }

    // 배송 불가 지역
    const getNodeDlvryArea = () => {
        let noneArea = '';

        // console.log("prodinfo : " + JSON.stringify(prodinfo));

        // 배송 불가 지역 없는 경우
        if (detailInfo.brandinfo.non_dlvry_area0) {
            return "없음";
        }

        // 제주 배송 불가 지역
        if (detailInfo.brandinfo.non_dlvry_area1) {
            noneArea += "제주";
        }

        // 도서 산간 지역
        if (detailInfo.brandinfo.non_dlvry_area2) {
            if (noneArea.length > 0) {
                noneArea += " / ";
            }

            noneArea += "도서산간지역";
        }

        // 배송불가 지역 기타
        if (detailInfo.brandinfo.non_dlvry_area3) {
            if (noneArea.length > 0) {
                noneArea += " / ";
            }

            noneArea += detailInfo.brandinfo.non_dlvry_extra;
        }

        return noneArea;
    }

    // 배송비
    const getQuantityPaid = () => {
        if (detailInfo.brandinfo.is_quantity_paid) {
            return "주문 상품 개수에 비례하여 배송비 부과";
        } else {
            return "없음"
        }
    }

    // 배송비 결제 방식
    const getDvryPayType = () => {

        if (detailInfo.brandinfo.dlvry_pay_type === '020201') {
            return "선불";
        } else if (detailInfo.brandinfo.dlvry_pay_type === '020201') {
            return '착불';
        } else {
            return '무료배송';
        }
    }

    if (detailInfo === null) {
        return <EsReqDvryGuideBlock />
    }

    return (
        <EsReqDvryGuideBlock>
            <div className="default-table margin_b-120">
                {isMobileOnly?
                  <React.Fragment>
                      <h3 className="">
                          배송안내
                          {/* <!-- CMS 에서 체크시 출력 되는 문구입니다. --> */}
                      </h3>
                      {
                          detailInfo.masterinfo.is_dlvry_notice === 0 ? "" :
                            <div className="ess_text">* 자세한 배송비는 상품 상세에서 확인해주세요.</div>
                      }

                      <table>
                          <tbody>
                          <tr>
                              <td className="gray">배송유형</td>
                              <td>{getDvryType()}</td>
                          </tr>
                          <tr>

                              <td className="gray">배송 불가 지역</td>
                              <td>{getNodeDlvryArea()}</td>
                          </tr>
                          <tr>
                              <td className="gray">배송비 지불방식</td>
                              <td>{getDvryPayType()}</td>
                          </tr>
                          <tr>
                              <td className="gray">지역별 차등 배송비</td>
                              <td>{detailInfo.brandinfo.dlvry_fee_extra}</td>
                          </tr>
                          <tr>
                              <td className="gray border_bottom">배송 예정일자</td>
                              <td className="border_bottom">{detailInfo.masterinfo.dlvry_method_name}</td>
                          </tr>
                          <tr>
                              <td className="gray border_bottom">비례 배송비</td>
                              <td className="border_bottom">{getQuantityPaid()}</td>
                          </tr>
                          </tbody>
                      </table>

                  </React.Fragment>
                  :
                  <React.Fragment>
                      <h3 className="dt-title">
                          배송안내
                          {/* <!-- CMS 에서 체크시 출력 되는 문구입니다. --> */}
                          {
                              detailInfo.masterinfo.is_dlvry_notice === 0 ? "" :
                                <div className="ess_text">* 자세한 배송비는 상품 상세에서 확인해주세요.</div>
                          }
                      </h3>
                      <table>
                          <colgroup>
                              <col width="180px;" />
                              <col width="410px;" />
                              <col width="180px;" />
                              <col width="410px;" />
                          </colgroup>

                          <tbody>
                          <tr>
                              <td className="gray">배송유형</td>
                              <td>{getDvryType()}</td>
                              <td className="gray">배송 불가 지역</td>
                              <td>{getNodeDlvryArea()}</td>
                          </tr>
                          <tr>
                              <td className="gray">배송비 지불방식</td>
                              <td>{getDvryPayType()}</td>
                              <td className="gray">지역별 차등 배송비</td>
                              <td>{detailInfo.brandinfo.dlvry_fee_extra}</td>
                          </tr>
                          <tr>
                              <td className="gray border_bottom">배송 예정일자</td>
                              <td className="border_bottom">{detailInfo.masterinfo.dlvry_method_name}</td>
                              <td className="gray border_bottom">비례 배송비</td>
                              <td className="border_bottom">{getQuantityPaid()}</td>
                          </tr>
                          </tbody>
                      </table>
                  </React.Fragment>
                }
            </div>
        </EsReqDvryGuideBlock>
    );
};

export default EsReqDvryGuide;
